import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'signal-g', 'SignalG', [["path",{"d":"M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"}]]);